import { backendFetch } from './apiUtils';

const NEENOR_BASE = 'neenor/';

export const postNeeNorFilter = async (filter = {}) => {
  return backendFetch({
    url: 'neenor/filter',
    method: 'POST',
    options: {
      body: JSON.stringify({ skip: 0, amount: 50, filter }),
      headers: { 'Content-Type': 'application/json' },
    },
  });
};

export const getBulkNeeNorDetailsFromIds = async (ids = []) => {
  return backendFetch({
    url: 'neenor/detailsWithIds',
    method: 'GET',
    params: { ids: '[' + ids.join(',') + ']' },
  });
};

export const putNeeNor = async (submit) => {
  return backendFetch({
    url: NEENOR_BASE,
    method: 'PUT',
    options: {
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(submit),
    },
  });
};
